import React from 'react';

const Timeline = ({ children }) => {
  const childrenArray = React.Children.toArray(children);
  
  return (
    <div className="timeline">
      {childrenArray.map((child, index) => (
        <div key={index} className="timeline-item">

          <div className="timeline-marker">
            <div className="timeline-circle" />
            {index !== childrenArray.length - 1 && <div className="timeline-line" />}
          </div>

          <div className="timeline-content">
            {child}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;